// initial state
const state = {
  fullHeight: false,
  activeTab: null
};

// mutations
const mutations = {
  fullHeightOn(state) {
    if (state.fullHeight === false) {
      console.log("Set page to full height mode");
      state.fullHeight = true;
    }
  },
  fullHeightOff(state) {
    if (state.fullHeight === true) {
      console.log("Restore page to normal height");
      state.fullHeight = false;
    }
  },
  setActiveTab(state, val) {
    console.log("Set activeTab to", val);
    state.activeTab = val;
  }
};

export default {
  namespaced: true,
  state,
  mutations
};
